export default function AboutSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#0077B6] to-[#005F8C]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Label */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded mb-6">
          <span className="text-white text-xs font-semibold tracking-wider">OUR STORY</span>
          <span className="text-white">/</span>
        </div>

        {/* Main Title and Description */}
        <div className="mb-16">
          <h3 className="text-5xl font-bold text-white mb-6 max-w-3xl" style={{ fontFamily: "'Playfair Display', serif" }}>
            Your Trusted Health Insurance Partner in Kerrville
          </h3>
          <p className="text-white/90 text-base leading-relaxed max-w-3xl">
            At <strong>West Insurance</strong>, we specialize in helping Kerrville families and businesses navigate 
            the complex world of health insurance. Whether you need private health insurance, group coverage for your 
            employees, or Medicare guidance, our experienced team provides personalized solutions tailored to your 
            healthcare needs and budget in Kerr County.
          </p>
        </div>

        {/* Split Layout */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <div className="w-full h-96">
            <img
              src="https://public.readdy.ai/ai/img_res/3cc7e833eca7e0d8a727ccefdc1be9e9.jpg"
              alt="West Insurance health insurance consultation at 243 La Reata Rd S, Kerrville, TX"
              title="West Insurance Kerrville health insurance experts"
              className="w-full h-full object-cover rounded-2xl shadow-2xl"
            />
          </div>

          {/* Right: Stats and CTA */}
          <div>
            <div className="mb-8">
              <div className="text-7xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                15+
              </div>
              <p className="text-white/90 text-lg leading-relaxed">
                Years helping <strong>Kerr County families</strong> find affordable health insurance coverage. 
                Our commitment to personalized service and expert guidance has made us a trusted name in 
                Kerrville health insurance solutions.
              </p>
            </div>
            <button
              onClick={() => {
                const element = document.getElementById('about-details');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-3 bg-white text-[#0077B6] text-sm font-semibold rounded-full hover:bg-gray-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Learn Our Story
            </button>
          </div>
        </div>

        {/* Additional About Content */}
        <div id="about-details" className="mt-20 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
              <i className="ri-heart-pulse-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-semibold text-white mb-3">Health Coverage Experts</h4>
            <p className="text-white/80 text-sm leading-relaxed">
              Specialized knowledge in private health insurance, group plans, Medicare, and supplemental coverage options.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
              <i className="ri-map-pin-user-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-semibold text-white mb-3">Local Kerrville Team</h4>
            <p className="text-white/80 text-sm leading-relaxed">
              Our Kerrville office understands the unique healthcare needs of Texas Hill Country residents and businesses.
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center">
              <i className="ri-hand-heart-line text-white text-3xl"></i>
            </div>
            <h4 className="text-xl font-semibold text-white mb-3">Personalized Care</h4>
            <p className="text-white/80 text-sm leading-relaxed">
              We take time to understand your health needs and create customized insurance solutions that fit your life.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
